import React from 'react';
import { motion } from 'framer-motion';
import { getWeddingConfig } from '../services/wedding-config';
import ScrollReveal from './animations/ScrollReveal';

const VenueInfo: React.FC = () => {
  const config = getWeddingConfig();
  
  const openGoogleMaps = () => {
    // Using coordinates for precise location and official Google Maps URL API
    const lat = '14.56627056275281';
    const lng = '-90.66956206069888';
    const venueName = encodeURIComponent(config.venue.name);

    // This format works on: iPhone, Android (opens app), MacBook, Windows (opens browser)
    window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${lng}&query_place_id=${venueName}`, '_blank');
  };

  const openWaze = () => {
    // Using coordinates for Waze - works better on mobile apps
    const lat = '14.56627056275281';
    const lng = '-90.66956206069888';
    // This format works on: iPhone, Android (opens app if installed), Desktop (opens web)
    window.open(`https://www.waze.com/ul?ll=${lat},${lng}&navigate=yes`, '_blank');
  };

  return (
    <section className="venue-info">
      {/* Background with gradient using existing palette */}
      <div className="venue-background">
        <div className="venue-background-overlay"></div>
      </div>

      {/* Header */}
      <ScrollReveal direction="up" delay={0.2}>
        <div className="venue-header">
          <h1 className="venue-subtitle">
            LUGAR Y UBICACIÓN
          </h1>
          <h2 className="venue-title-script">
            Nuestra Celebración
          </h2>
        </div>
      </ScrollReveal>

      <ScrollReveal direction="up" delay={0.4}>
        <div className="venue-content">
          <div className="venue-address-section">
            <p>Fecha: Domingo 14 de diciembre 2025</p>
            <p>Hora: 4:30 p.m.</p>
          </div>
        </div>
      </ScrollReveal>

      {/* Content */}
      <ScrollReveal direction="up" delay={0.6}>
        <div className="venue-content">
          <h3 className="venue-name">
            {config.venue.name}
          </h3>

          <div className="venue-address-section">
            {config.venue.address.split(',').map((line, index) => (
              <p key={index}>{line.trim()}</p>
            ))}
            {/* {config.venue.phone && <p>Tel: {config.venue.phone}</p>} */}
          </div>

          <div className="venue-buttons">
            <motion.button
              onClick={openWaze}
              className="rsvp-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Ver en Waze
            </motion.button>
            <motion.button
              onClick={openGoogleMaps}
              className="rsvp-btn"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Ver en Google Maps
            </motion.button>
          </div>
        </div>
      </ScrollReveal>

      {/* Bottom spacing */}
      <div className="venue-bottom"></div>
    </section>
  );
};

export default VenueInfo;